/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-list-user-group a{cursor:pointer!important}app-list-user-group .search-container{text-align:right;position:relative}app-list-user-group .search-container .pi-search{position:absolute;right:0}app-list-user-group .filterInput{margin:5px 4px 0 0}app-list-user-group .ui-dialog-content{max-height:350px!important}"];
export { styles as styles };
